/**
 * Shared TanStack QueryClient for the archivio feature — F-006 Phase 5.
 *
 * A feature-scoped QueryClient avoids coupling to a global app-wide client
 * (which doesn't exist yet in this codebase). Mounted by `ArchivioPage` /
 * `PraticaDetailPage` via `QueryClientProvider`.
 *
 * Defaults chosen for archivio UX:
 *  - `staleTime: 30_000` — list/detail pages stay fresh for 30s so navigating
 *    away and back doesn't trigger an immediate refetch.
 *  - `retry: 1` — one retry on transient network errors before surfacing.
 *  - `refetchOnWindowFocus: false` — list page would re-flash on tab focus.
 */
import { QueryClient } from '@tanstack/react-query';

export function createArchivioQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 1,
      },
    },
  });
}

/**
 * Module-level singleton — sufficient for the feature: the QueryClient lives
 * for the SPA session, and a single client across `/app/archivio` and
 * `/app/archivio/:id` lets cached list rows pre-populate the detail page
 * (future optimization).
 */
export const archivioQueryClient = createArchivioQueryClient();
